import { Col, ColProps } from "react-bootstrap";
import { FormCard } from ".";
import { ReactNode } from "react";

interface FormColProps extends ColProps {
    withCard?: boolean;
    cardTitle?: ReactNode;
    suppressMargin?: boolean;
    footer?: ReactNode;
    dark?: boolean;
    headerRightElement?: ReactNode;
}

export function FormCol({
    withCard,
    className,
    cardTitle,
    suppressMargin,
    footer,
    headerRightElement,
    dark,
    children,
    ...props
}: Readonly<FormColProps>) {
    if (withCard || cardTitle) {
        return (
            <Col className={`d-flex align-items-stretch ${className ?? ""}`} {...props}>
                <FormCard
                    title={cardTitle ?? ""}
                    suppressMargin={suppressMargin}
                    footer={footer}
                    headerRightElement={headerRightElement}
                    dark={dark}
                >
                    {children}
                </FormCard>
            </Col>
        );
    }

    return (
        <Col className={`d-flex align-items-stretch ${className ?? ""}`} {...props}>
            {children}
        </Col>
    );
}
